import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { MdCheck } from 'react-icons/md';
import Link from '../../../shared/Link/Link';
import Price from '../../../shared/Price/Price';
import {
  purchase,
  pushRemarketingEvent,
} from '../../../shared/lib/gaEnhancedEcommerce';
import { ga4Purchase } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxPurchase } from '../../../shared/lib/farmakomMetrics';
import {
  gAdsConversion,
  gAdsPurchase,
} from '../../../shared/lib/gAdsEnhancedEcommerce';
import { loadOrder } from '../../../../redux/modules/singleOrder';
import { emptyCart, loadCart } from '../../../../redux/modules/cart';
import { resetCheckout } from '../../../../redux/modules/checkout';
import { getSHA256Hash } from '../../../../utils/sha256';
import api from '../../../../api';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';
import './CheckoutResult.scss';
import IubendaCookieSolution from '../../../../utils/iubenda';

// RIMOSSO PERCHÉ SE L'UTENTE FA UN ORDINE ALLORA HA ACCETTATO LA PRIVACY
// import IubendaCookieSolution from '../../../../utils/iubenda';

class CheckoutSuccess extends Component {
  componentDidMount() {
    // const iubenda = new IubendaCookieSolution(
    //   this.props.hasIubendaCookieSolution
    // );

    this.props.loadOrder(
      this.props.location.query.orderId || this.props.checkout.orderId,
      this.props.location.query.userEmail
    );

    // JQUERY
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://code.jquery.com/jquery-1.4.min.js';
    document.head.appendChild(script1);

    // TROVAPREZZI
    if (!this.props.hasTrovaprezziTrustedProgram) {
      // Lo facciamo solo se non è attivo il trusted perchè se hanno
      // il trusted program è già importato nell'head del sito
      const script2 = document.createElement('script');
      script2.src =
        'https://tracking.trovaprezzi.it/javascripts/tracking-vanilla.min.js';

      // iubenda.proceedIfHasConsent(() =>
      setTimeout(() => {
        document.head.appendChild(script2);
      }, 100);
      // );
    }

    // Reset cart
    if (!this.props.location.query.pay_later) {
      this.props.emptyCart();
      this.props.loadCart();
    }
    // Reset coupon
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('coupon');
    }
    // Reset checkout
    this.props.resetCheckout();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.order !== prevProps.order &&
      this.props.order.items &&
      this.props.order.items.length > 0
    ) {
      this.trackOrder();
    }
  }

  trackOrder() {
    const { order, trovaprezziId } = this.props;

    // SETUP IUBENDA
    // const iubenda = new IubendaCookieSolution(hasIubendaCookieSolution);

    /////////////////////////////////
    // GOOGLE ANALYTICS: TRANSACTION
    const productsGA = order.items.map(p => ({
      id: p.minsanCode || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));

    const transactionGA = {
      id: order.id,
      revenue: order.grandTotal,
      tax: order.totalTax,
      shipping: order.totalShipping,
      coupon: order.coupon.name,
    };

    // GA4 PURCHASE
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4Purchase({
        id: order.id,
        revenue: order.grandTotal,
        tax: order.totalTax,
        shipping: order.totalShipping,
        coupon: order.coupon.name,
        items: order.items,
      });
    }
    //GADS PURCHASE
    if (
      !!this.props.hasGoogleAdsTag &&
      !!this.props.gAdsTrackingId &&
      !!this.props.gAdsGoalId
    ) {
      // Conversions for Ads
      gAdsConversion(
        {
          ...order,
          id: order.id,
          revenue: order.grandTotal,
        },
        this.props.gAdsTrackingId,
        this.props.gAdsGoalId
      );
      // Purchase for dynamic pricing
      gAdsPurchase(
        {
          ...order,
          id: order.id,
          revenue: order.grandTotal,
          tax: order.totalTax,
          shipping: order.totalShipping,
          coupon: order.coupon.name,
          items: order.items,
        },
        this.props.gAdsTrackingId,
        this.props.gAdsGoalId,
        {
          glsShipping: this.props.glsShipping,
          costiSpedizione: this.props.costiSpedizione,
        }
      );
    }

    // FKMX PURCHASE
    if (this.props.hasFarmakomMetrics) {
      fkmxPurchase({
        id: order.id,
        revenue: order.grandTotal,
        tax: order.totalTax,
        shipping: order.totalShipping,
        coupon: order.coupon.name,
        items: order.items.map(item => {
          const categoryName = item.parentCategoryName;
          const subcategoryName = item.categoryName;
          const brand = item.brandStandard;
          return {
            ...item,
            brand,
            categoryName,
            subcategoryName,
          };
        }),
      });
    }

    // SEND EVENT
    if (this.props.advancedGa) {
      purchase(productsGA, transactionGA);
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('purchase', order.items);
    }

    /////////////////////////////
    // TROVAPREZZI
    if (!!trovaprezziId) {
      if (!!this.props.hasIubendaCookieSolution) {
        this.renderTrovaprezziIubendaScript();
      } else {
        this.renderTrovaprezziScript();
      }
    }

    /////////////////////////////
    // TRANSACTIONALE
    if (!!window._trx) {
      const transactionaleItems = order.items.map(item => {
        return {
          id: item.productId,
          price: item.price,
          quantity: item.quantity,
        };
      });

      // iubenda.proceedIfHasConsent(() => {
      window._trx.push({
        event: 'trackTransaction',
        transaction: {
          id: order.id,
          total: order.grandTotal,
        },
        items: transactionaleItems,
        address: {
          address: order.shipping.address1 || '',
          address2: order.shipping.address2 || '',
          city: order.shipping.city || '',
          postalCode: order.shipping.zipcode || '',
          country: order.shipping.country || 'IT',
        },
        customer: {
          email: order.userEmail,
          optin: false, // Default to false
        },
        touchpointType: 'auto',
      });
      // });
    }

    ///////////////////////////
    // CRITEO
    if (this.props.hasCriteo) {
      // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      this.renderCriteoTag();
    }

    ///////////////////////////////
    // KELKOO
    if (this.props.hasKelkoo && this.props.kelkooMerchantId) {
      // iubenda.proceedIfHasConsent(() => this.renderKelkooScript());
      this.renderKelkooScript();
    }

    //////////////////////////////
    // TRADETRACKER
    if (this.props.hasTradeTracker) {
      // iubenda.proceedIfHasConsent(() => this.renderTradeTrackerScript());
      this.renderTradeTrackerScript();
    }

    //////////////////////////////
    // TRADEDOUBLER
    if (this.props.hasTradedoubler) {
      // iubenda.proceedIfHasConsent(() => this.renderTradeTrackerScript());
      this.renderTradedoublerScript();
    }
  }

  renderTrovaprezziScript = () => {
    const { order, email, trovaprezziId } = this.props;
    const userEmail = order.userEmail;

    const script = document.createElement('script');

    const orderItems = order.items.reduce((acc, item) => {
      return (
        acc +
        `window._tpt.push({ event: 'addItem', sku: '${item.productId}', product_name: '${item.name}' });`
      );
    }, '');

    script.innerHTML = `window._tpt = window._tpt || [];
      ${
        !!userEmail || !!email
          ? `window._tpt.push({ event: 'setEmail', email: '${userEmail ||
              email}' });`
          : ''
      }
      ${orderItems}
      window._tpt.push({ event: 'setAccount', id: '${trovaprezziId}' });
      window._tpt.push({ event: 'setOrderId', order_id: '${order.id}' });
      window._tpt.push({ event: 'setAmount', amount: '${order.grandTotal}' });
      window._tpt.push({ event: 'orderSubmit'});`;

    setTimeout(() => {
      document.body.appendChild(script);
    }, 200);
  };

  renderTrovaprezziIubendaScript = () => {
    const { order, email, trovaprezziId } = this.props;
    const userEmail = order.userEmail;

    // Purpose 1 means that the script is always loaded
    const scriptPurpose5 = document.createElement('script');
    const orderItems = order.items.reduce((acc, item) => {
      return (
        acc +
        `window._tpt.push({ event: 'addItem', sku: '${item.productId}', product_name: '${item.name}' });`
      );
    }, '');
    scriptPurpose5.innerHTML = `window._tpt = window._tpt || [];
      ${
        !!userEmail || !!email
          ? `window._tpt.push({ event: 'setEmail', email: '${userEmail ||
              email}' });`
          : ''
      }
      ${orderItems};`;

    const scriptPurpose1 = document.createElement('script');
    scriptPurpose1.innerHTML = `window._tpt = window._tpt || [];
      window._tpt.push({ event: 'setAccount', id: '${trovaprezziId}' });
      window._tpt.push({ event: 'setOrderId', order_id: '${order.id}' });
      window._tpt.push({ event: 'setAmount', amount: '${order.grandTotal}' });
      window._tpt.push({ event: 'orderSubmit'});`;

    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    setTimeout(() => {
      iubenda.proceedIfHasConsent(() => {
        document.head.appendChild(scriptPurpose5);
      });
      setTimeout(() => {
        document.head.appendChild(scriptPurpose1);
      }, 500);
    }, 200);
  };

  renderKelkooScript = () => {
    const { order } = this.props;

    if (order) {
      const scriptKelkoo = document.createElement('script');

      scriptKelkoo.innerHTML = `
        _kkstrack = {
          merchantInfo : [{ country:"it", merchantId:"${this.props.kelkooMerchantId}" }],
          orderValue: ${order.grandTotal},
          orderId: ${order.id}
        };
        (function() {
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://s.kk-resources.com/ks.js';
          var x = document.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        })();
      `;

      setTimeout(() => {
        document.body.appendChild(scriptKelkoo);
      }, 300);
    }
  };

  renderCriteoTag = () => {
    // <!-- Criteo Basket/Cart Tag -->
    const { order } = this.props;
    if (order) {
      const email = (order && order.userEmail) || '';
      const zipcode = (order && order.shipping && order.shipping.zipcode) || '';

      // creo order items
      const orderItems = order.items.reduce((acc, curr) => {
        return (
          acc +
          `{id: "${curr.productId}", price: ${curr.price}, quantity: ${curr.quantity} },`
        );
      }, ``);

      // rimuovo il vecchio tag
      const oldTag = document.getElementById('criteo_sales_tag');
      if (oldTag) {
        document.body.removeChild(oldTag);
      }

      const criteo_sales_tag = document.createElement('script');
      criteo_sales_tag.id = 'criteo_sales_tag';
      criteo_sales_tag.type = 'text/javascript';
      criteo_sales_tag.innerHTML = `
          window.criteo_q = window.criteo_q || [];
          var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
          window.criteo_q.push(
          { event: "setAccount", account: ${this.props.criteoAccountId}},
          ${
            !!email
              ? `{ event: "setEmail", email: "${getSHA256Hash(
                  email
                )}", hash_method: "sha256" },`
              : ''
          }
          { event: "setZipcode", zipcode: "${zipcode}" },
          { event: "setSiteType", type: deviceType},
          { event: "trackTransaction", id: "${this.props.order.id}", item: [
            ${orderItems}
          ]});
      `;
      setTimeout(() => {
        document.body.appendChild(criteo_sales_tag);
      }, 200);
    }
    // <!-- END Criteo Basket/Cart Tag -->
  };

  renderTradeTrackerScript = () => {
    const { order, tradeTracker } = this.props;
    if (order && tradeTracker.campaignId && tradeTracker.productId) {
      const trade_tracker_script_1 = document.createElement('script');
      trade_tracker_script_1.id = 'trade_tracker_script_1';
      trade_tracker_script_1.type = 'text/javascript';
      trade_tracker_script_1.innerHTML = `
        var ttConversionOptions = ttConversionOptions || [];
        ttConversionOptions.push({
          type: 'sales',
          campaignID: '${tradeTracker.campaignId}',
          productID: '${tradeTracker.productId}',
          transactionID: '${order.id}',
          transactionAmount: '${this.getTotalWithoutTaxAndShipment()}',
          quantity: '1',
          descrMerchant: '',
          descrAffiliate: '',
          vc: '',
          currency: ''
        });
      `;
      const trade_tracker_script_2 = document.createElement('script');
      trade_tracker_script_2.id = 'trade_tracker_script_2';
      trade_tracker_script_2.type = 'text/javascript';
      trade_tracker_script_2.innerHTML = `
        // No editing needed below this line.
        (function(ttConversionOptions) {
          var campaignID = 'campaignID' in ttConversionOptions ? ttConversionOptions.campaignID : ('length' in ttConversionOptions && ttConversionOptions.length ? ttConversionOptions[0].campaignID : null);
          var tt = document.createElement('script'); tt.type = 'text/javascript'; tt.async = true; tt.src = '//tm.tradetracker.net/conversion?s=' + encodeURIComponent(campaignID) + '&t=m';
          var s = document.getElementsByTagName('script'); s = s[s.length - 1]; s.parentNode.insertBefore(tt, s);
        })(ttConversionOptions);
      `;
      setTimeout(() => {
        document.body.appendChild(trade_tracker_script_1);
        document.body.appendChild(trade_tracker_script_2);
      }, 200);
    }
  };

  renderTradedoublerScript = async () => {
    const { order, tradedoubler, storeId } = this.props;

    let ordersCount = 0;
    try {
      const { endpoint, headers, method } = api.getOrdersCount();
      const orders = await axios({
        url: endpoint,
        method,
        headers: {
          ...headers,
          storeid: storeId,
        },
      });
      ordersCount = orders.data;
    } catch (error) {
      console.error('error getting orders count: ', error);
    }

    if (!!order && !!tradedoubler.organization) {
      let eventCode = '';

      if (!!order.userId) {
        if (ordersCount > 1) {
          eventCode = tradedoubler.eventPurchaseRecurringUser;
        } else {
          eventCode = tradedoubler.eventPurchaseNewUser;
        }
      } else {
        eventCode = tradedoubler.eventPurchaseGuest;
      }

      if (!eventCode) {
        return;
      }

      let orderValue = this.getTotalWithoutTaxAndShipment();

      let couponDiscount = this.getTotalCoupons();

      orderValue = orderValue - couponDiscount;

      const tradedoubler_iframe = document.createElement('iframe');
      tradedoubler_iframe.id = 'tradedoubler_iframe';
      tradedoubler_iframe.src = `https://tbs.tradedoubler.com/report?organization=${tradedoubler.organization}&event=${eventCode}&ordernumber=${order.id}&orderValue=${orderValue}&currency=EUR&type=iframe`;
      tradedoubler_iframe.width = '1';
      tradedoubler_iframe.height = '1';

      const tradedoubler_img = document.createElement('img');
      tradedoubler_img.id = 'tradedoubler_img';
      tradedoubler_img.src = `https://img-statics.com/report?o=${tradedoubler.organization}&e=${eventCode}&ordnum=${order.id}&ordval=${orderValue}&curr=EUR`;
      tradedoubler_img.alt = '';
      tradedoubler_img.style = 'width:0;height:0;border:none';

      setTimeout(() => {
        const tradedoubleContainer = document.getElementById(
          'tradedoubler_container'
        );
        tradedoubleContainer.appendChild(tradedoubler_iframe);
        tradedoubleContainer.appendChild(tradedoubler_img);
      }, 200);
    }
  };

  getTotalWithoutTaxAndShipment = () => {
    const total = this.props.order.items.reduce((acc, curr) => {
      return (
        acc +
        ((curr.price * 100) / (100 + (curr.taxRate || 0))) *
          (curr.quantity || 1)
      );
    }, 0);
    return Math.round((total + Number.EPSILON) * 100) / 100;
  };

  getTotalItems = () => {
    const total = this.props.order.items.reduce(
      (acc, curr) => acc + curr.price * (curr.quantity || 1),
      0
    );
    return Math.round((total + Number.EPSILON) * 100) / 100;
  };

  render() {
    const {
      bankName,
      bankAccount,
      order,
      primaryColor,
      uiVariantButton,
      hasTradeTracker,
      tradeTracker,
    } = this.props;

    return (
      <div className="checkout-result checkout-success">
        {/* TRANSACTIONALE */}
        <div id="tr_touchpoint_container" />

        {/* TRADETRACKER - FIXME: credo che funzioni male, sarebbe da caricare solo dopo che viene caricato order */}
        {hasTradeTracker && tradeTracker.campaignId && tradeTracker.productId && (
          <noscript>
            <ImageDispatcher
              src={`//ts.tradetracker.net/?cid=${
                tradeTracker.campaignId
              }&amp;pid=${tradeTracker.productId}&amp;tid=${
                order.id
              }&amp;tam=${this.getTotalWithoutTaxAndShipment()}&amp;data=&amp;qty=1&amp;descrMerchant=&amp;descrAffiliate=&amp;event=sales&amp;currency=EUR&amp;vc=`}
              alt="Trade tracker"
            />
          </noscript>
        )}

        {/* TRADEDOUBLER */}
        <div id="tradedoubler_container" />

        <div
          className="check"
          style={{
            color: primaryColor,
            borderColor: primaryColor,
            borderRadius:
              uiVariantButton === '1'
                ? '35px'
                : uiVariantButton === '3'
                ? '50%'
                : 0,
          }}
        >
          <MdCheck />
        </div>

        {this.props.location.query.payment_link ? (
          <div>
            <h1>Pagamento effettuato!</h1>

            <div className="paymentInstruction">
              <p>
                Il pagamento di{' '}
                <Price amount={this.props.location.query.importo} /> è stato
                effettuato correttamente.
              </p>
            </div>
          </div>
        ) : (
          <div>
            <h1>Ordine inoltrato con successo!</h1>

            <div className="paymentInstruction">
              <p>Ti abbiamo inviato una mail con i dettagli del tuo ordine.</p>
            </div>
          </div>
        )}

        {order.payment.typeName &&
          order.payment.typeName.toLowerCase() === 'bonifico' && (
            <div className="paymentInstruction grey">
              <p>
                Ricorda che il tuo ordine sarà preso in carico alla ricezione
                del pagamento.
              </p>
              <p>
                Restiamo in attesa del bonifico bancario di{' '}
                <b>
                  <Price amount={order.grandTotal} />
                </b>{' '}
                su:
              </p>
              <p>
                {bankName} - IBAN: <b>{bankAccount}</b>, indicando come causale
                "P{order.id}"
              </p>
            </div>
          )}

        {order.payment.typeName &&
          order.payment.typeName.toLowerCase() === 'contrassegno' && (
            <div className="paymentInstruction grey">
              <p>
                Ricorda che dovrai pagare <Price amount={order.grandTotal} /> in
                contrassegno al corriere.
              </p>
            </div>
          )}

        <Link to="/" className="btn btn-primary">
          Torna al negozio
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
  storeId: state.store.data.storeId,
  checkout: state.checkout,
  glsShipping: state.store.data.glsShipping,
  costiSpedizione: state.store.data.costiSpedizione,
  bankName: state.store.data.datiFarmacia.bankName,
  bankAccount: state.store.data.datiFarmacia.bankAccount,
  trovaprezziId: state.store.data.integrazioni.trovaprezzi.id,
  email: state.user.data.email,
  order: state.singleOrder.data,
  advancedGa: state.store.data.features.advancedGa,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
  hasCriteo: state.store.data.features.hasCriteo,
  hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
  criteoAccountId: state.store.data.integrazioni.criteo.accountId,
  kelkooMerchantId: state.store.data.integrazioni.kelkoo.merchantId,
  hasKelkoo: state.store.data.features.hasKelkoo,
  hasTradeTracker: state.store.data.features.hasTradeTracker,
  tradeTracker: state.store.data.integrazioni.tradeTracker,
  hasTradedoubler: state.store.data.features.hasTradedoubler,
  hasTrovaprezziTrustedProgram:
    state.store.data.features.hasTrovaprezziTrustedProgram,
  tradedoubler: state.store.data.integrazioni.tradedoubler,
  hasIubendaCookieSolution: state.store.data.features.hasIubendaCookieSolution,
  hasGoogleAnalytics4Advanced: !!state.store.data.features
    .hasGoogleAnalytics4Advanced,
  hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  gAdsTrackingId: state.store.data.integrazioni.google.gAdsTrackingId,
  gAdsGoalId: state.store.data.integrazioni.google.gAdsGoalId,
  hasGoogleAdsTag: state.store.data.features.hasGoogleAdsTag,
});

export default connect(mapStateToProps, {
  loadOrder,
  emptyCart,
  loadCart,
  resetCheckout,
})(CheckoutSuccess);
